// extracted by mini-css-extract-plugin
module.exports = {"CloseModalBtn":"UpdateAssets_CloseModalBtn__2NjWP","ShowInstruction":"UpdateAssets_ShowInstruction__37GYD"};